/*  ========================================================================
    # Scripts - Header Menu Mobile
    ========================================================================  */

const HeaderMenuMobile = {
  cfg: {
    button: document.querySelector('.c-header__burger'),
    mobileMenu: document.querySelector('.c-header-menu-mobile'),
    background: document.querySelector('.c-header-menu-mobile__background'),
    mobileMenuClose: document.querySelector('.c-header-menu-mobile__close'),
    classes: {
      mobileMenuActive: 'c-header-menu-mobile--active'
    }
  },

  handleShowHide() {
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    } else {
      document.body.style.overflow = 'hidden';
    }

    this.cfg.mobileMenu?.classList.toggle(this.cfg.classes.mobileMenuActive);
  },

  init() {
    this.cfg.button.addEventListener('click', () => {
      this.handleShowHide();
    });

    this.cfg.background.addEventListener('click', () => {
      this.handleShowHide();
    });

    this.cfg.mobileMenuClose.addEventListener('click', () => {
      this.handleShowHide();
    });
  }
};

export default HeaderMenuMobile;
